<template>
  <input-button
    :state="innerValue ? (light ? 'active-light' : 'active') : null"
    @click.prevent.stop="toggle"
  >
    <slot />
  </input-button>
</template>

<script>
import InputButton from './InputButton';

export default {
  name: 'InputButtonToggle',
  components: {
    InputButton,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      required: false,
    },
    light: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerValue: this.value,
    };
  },
  watch: {
    innerValue() {
      if (this.innerValue === this.modelValue) {
        return;
      }

      this.$emit('update:modelValue', this.innerValue);
    },
    modelValue() {
      if (this.innerValue === this.modelValue) {
        return;
      }

      this.innerValue = !!this.modelValue;
    },
  },
  mounted() {
    this.innerValue = this.modelValue;
  },
  methods: {
    toggle() {
      this.innerValue = !this.innerValue;
    },
  },
};

</script>
